import Wprr from "wprr";
import React from "react";

import ElfsightReviewWidget from "./ElfsightReviewWidget.js";

export default class Reviews extends Wprr.BaseObject {
	
	_construct() {
		super._construct();
	}

	_renderMainElement() {
		
		return <React.Fragment>
			<ElfsightReviewWidget />
		</React.Fragment>;
	}
	
	static getWpAdminEditor() {
		console.log("getWpAdminEditor");
		
		let dataSettings = {
			
		};
		
		return <Wprr.layout.admin.WpBlockEditor dataSettings={dataSettings}>
			<div>
				
			</div>
		</Wprr.layout.admin.WpBlockEditor>;
	}
}